import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { getAdministrativeDocumentYearsOptions } from 'src/utils/utils';
import { clearListAllAdministrativeServicesData } from "src/redux/administrativeService/administrativeServiceActions";
import { getListAllServiceAdministrativeByUserData } from "src/redux/administrativeService/administrativeServiceReducer";
import { getSelectedFundRequestType } from 'src/redux/fundRequests/fundRequestsReducer';
import { getBankAccountListData } from 'src/redux/bankAccounts/bankAccountReducer';
import { getProvisionOrderListIsFetching, getProvisionOrderListData } from 'src/redux/orderPay/orderPayReducer';
import { tryListProvisionOrder } from 'src/redux/orderPay/orderPayActionCreator';
import { clearListProvisionOrderData } from 'src/redux/orderPay/orderPayActions'
import PFCommons from 'src/components/forms/fundRequest/PDForms/controls/PFCommons';
import AppLoading from 'src/components/common/AppLoading';
import ProvisionOrderListBox from "src/components/forms/fundRequest/provisionOrderListBox";

const FundRequestProvisionAgainstDeliveryForm = () => {
	const dispatch = useDispatch();

	//Parent Form Controller
	const { admServiceId, setAdmServiceId } = useFormContext();

	//Data getter to send by props
	const dataRecords = useSelector(state => getProvisionOrderListData(state))?.records;
	const metaData = useSelector(state => getProvisionOrderListData(state))?.metadata;

	const selectedFundRequestType = useSelector(state => getSelectedFundRequestType(state));
	const checkToVisualize = false;
	const bankAccountListData = useSelector(state => getBankAccountListData(state))?.records || [];
	const yearsOptions = getAdministrativeDocumentYearsOptions();
	const [bankAccountListDataFiltered, setBankAccountListDataFiltered] = useState([]);
	const isFetching = useSelector(state => getProvisionOrderListIsFetching(state));

	const administrativeServiceData = useSelector(state => getListAllServiceAdministrativeByUserData(state))
		?.sort((a, b) => a.code > b.code ? 1 : -1)
		?.map(item => ({
			displayName: `${item?.code} - ${item?.name}`,
			id: item?.id,
			name: item?.name
		}));

	useEffect(() => {
		dispatch(clearListAllAdministrativeServicesData());
		dispatch(clearListProvisionOrderData());
	}, [admServiceId]);

	const applyFilterBankAccounts = (administrativeServiceId) => {
		setAdmServiceId(administrativeServiceId);
		setBankAccountListDataFiltered(bankAccountListData?.filter(item => item.administrativeServiceId == administrativeServiceId));
	};

	return <>
		<PFCommons
			yearsOptions={yearsOptions}
			administrativeServiceData={administrativeServiceData}
			applyFilterBankAccounts={applyFilterBankAccounts}
			bankAccountListDataFiltered={bankAccountListDataFiltered}
			admServiceId={admServiceId}
			checkToVisualize={checkToVisualize}
		/>

		<ProvisionOrderListBox
			administrativeServiceData={administrativeServiceData}
			selectedFundRequestType={selectedFundRequestType}
			isFetching={isFetching}
			tryMethod={tryListProvisionOrder}
			clearMethod={clearListProvisionOrderData}
			metaData={metaData}
			dataRecords={dataRecords}
			acquisitionType='CONTRATACION_DIRECTA_CONTADO_CONTRA_ENTREGA'
			provisionOrders={dataRecords}
		/>

		<AppLoading isLoading={isFetching} />
	</>

};

export default FundRequestProvisionAgainstDeliveryForm;